class Customer.SignatureAppendToNewTicketView extends Backbone.View
  template: JST['backbone/templates/customer/ticket/signatures/append_to_new_ticket']

  initialize: ({model}) ->
    @model = model

  render: ->
    @$el.html(@template(model: @model))
    @_renderButton()
    @_initializeTooltip()
    @

  _renderButton: ->
    @button = @$el.find('#append-to-new-ticket')
    @button.bootstrapToggle({width: 80, height: 20})

  _initializeTooltip: ->
    @$el.find('[data-toggle=tooltip]').tooltip()

  getValue: ->
    @button.prop('checked')
